import React, { useEffect } from 'react';
import { Copy, Square } from '@grubhubprod/gh-cookbook-react';
import { useAnalytics } from 'src/components/AnalyticsProvider/AnalyticsProvider';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { EmployeeListTable } from 'src/components/enterprise/features/Employee/EmployeeListPage/components/EmployeeListTable/EmployeeListTable';

export function EmployeeListPage(): JSX.Element {
  const { sendTealiumPageView } = useAnalytics();

  useEffect(() => {
    sendTealiumPageView({
      pagegroup: 'corporate admin',
      pagesubgroup: 'manage employees_home',
    });
    // eslint-disable-next-line no-autofix/react-hooks/exhaustive-deps
  }, []);

  return (
    <Square inset="lg">
      <PageHeader>
        <PageTitle title="Employees" />
        <Copy variant="body">
          View and manage employees from your organization who are able to order
          food from Grubhub.
        </Copy>
      </PageHeader>
      <EmployeeListTable />
    </Square>
  );
}
